import React from 'react';
import PropTypes from 'prop-types';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

export class CompReportEntryRow extends React.Component {
  static propTypes = {
    ...listItemPropTypes,
    entry: PropTypes.shape({
      comp: PropTypes.shape({
        buildingSizeLabel: PropTypes.string,
        displayName: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        propertyType: PropTypes.string
      })
    }),
    onRemoveEntry: PropTypes.func
  }

  render() {
    const { comp } = this.props.entry;

    const style = {
      opacity: this.props.isDragging ? 0 : 1,
    };

    return this.props.connectDragPreview(this.props.connectDropTarget(
      <tr key={comp.id} name="compRow" style={style}>
        {this.props.connectDragSource(
          <td className="cursor-move">
            <span className="right-buffer-md text-muted">
              <FontAwesomeIcon icon={faEllipsisV}/>
            </span>
            {comp.displayName}
          </td>
        )}
        <td>{comp.propertyType}</td>
        <td>{comp.buildingSizeLabel}</td>
        <td className="text-right">
          <FontAwesomeIcon
            className="text-danger clickable"
            icon={faTrashAlt}
            name="remove"
            onClick={() => this.props.onRemoveEntry(comp)}
          />
        </td>
      </tr>
    ));
  }
}

export default reorderableListItem(CompReportEntryRow, "CompReportEntriesTable", {
  beginDrag(props) {
    return {
      id: props.entry.comp.id,
      index: props.index
    };
  }
});
